<template>
  <ModalDialog
    :show="show"
    is-simple
    simple-ok-label="Close anyway"
    simple-cancel-label="Continue with test"
    @ok="$emit('close')"
    @cancel="$emit('cancel')"
    @closed="$emit('cancel')"
  >
    <div>
      <template v-if="isMaths">
        You haven't completed this activity. Are you sure you want to close it?
      </template>
      <template v-else>
        If you close now you will lose all your progress and your points will not be saved.
      </template>
    </div>
  </ModalDialog>
</template> 

<script lang="ts">
import { defineComponent } from "vue";
import ModalDialog from "../ui/ModalDialog.vue";

export default defineComponent({    
  components: { ModalDialog },
  props: {
    show: { type: Boolean, required: true },
    isMaths: { type: Boolean, required: true },
  },
  data() {
      return {
      }
  },
});
</script>